<template>
    <contact-details :contactId="props.contactId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center gap-2 md:gap-2">
            <vx-box class="bg-slate-50 flex flex-col max-w-(--breakpoint-sm) p-8 text-xl mb-8" color="info">
                <h2 class="text-xl font-extrabold leading-7 text-slate-700">
                    Custom Attributes
                </h2>
                <p class="text-sm font-sans text-slate-500 lg:text-base">
                    Structured data for this contact. These can be used in other resources such as segments, campaigns and snippets.
                </p>
            </vx-box>

            <div v-if="loading && !list.length" class="text-center py-10">
                <vx-icon-loading class="w-9 h-9 animate-loading-spin"></vx-icon-loading>
            </div>

            <template v-else-if="!loading && list.length === 0">
                <vx-box color="info" class="mt-8 flex flex-col px-8 py-20 gap-6 items-center text-xl text-slate-500">
                    There are no custom attributes for this contact.
                </vx-box>
            </template>
            <template v-else>
                <vx-table v-if="list.length" class="xl:grid-cols-6" rowBreakpoint="xl">
                    <vx-table-row isHeader>
                        <div>
                            Key
                        </div>
                        <div class="xl:col-span-3!">
                            Value
                        </div>
                        <div>
                            Added at
                        </div>
                        <div>
                            Updated at
                        </div>
                    </vx-table-row>
                    <contact-custom-attribute-row v-for="(item, index) in list"
                        v-model="list[index]"
                        :key="item.id"></contact-custom-attribute-row>
                </vx-table>
            </template>
        </div>
    </contact-details>
</template>

<script setup>

import ContactDetails from '../ContactDetails.vue';
import { VxBox, VxIconLoading, VxTable, VxTableRow } from '@voxie/frontend-components';
import ContactCustomAttributeRow from './ContactCustomAttributeRow.vue';
import { useContactDetails } from '../useContactDetails';

const { onMountedContact, customAttributes: list, loadingCustomAttributes: loading, getCustomAttributes } = useContactDetails();

const props = defineProps({
    contactId: {
        type: Number,
        required: true,
    },
});

onMountedContact(() => {
    getCustomAttributes()
});
</script>
